import { ColorContext } from 'App';
import { usePerms } from 'contexts/PermsContext';
import { GetRouteData } from 'data/routeData';
import { AuthContext } from 'features/Auth/contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { FaHome } from 'react-icons/fa';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import { PiVideoFill, PiWrenchFill } from 'react-icons/pi';
import { RxHamburgerMenu } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import { _Environment } from 'services/_infra/environment';
import { getLogo } from 'utils/imageUtils';
import styles from './assets/nav.module.css';
import openLogo from './assets/Sidebar_Logo_Open.png';
import openLogoCOMALTX from './assets/Sidebar_Logo_Open_ComalTX.png';
import openLogoDEV from './assets/Sidebar_Logo_Open_DEV.png';
import openLogoHARRISONKY from './assets/Sidebar_Logo_Open_HarrisonKY.png';
import openLogoPITTSBURGHPA from './assets/Sidebar_Logo_Open_PittsburghPA.png';
import openLogoSTAGING from './assets/Sidebar_Logo_Open_STAGING.png';
/**
 * @param {function} onOpenChanged a funciton listening for when the sidebar open state changes.
 * @param {string} selected the name of the screen that is currently selected. This is so we know which button to highlight as 'selected'
 * @returns
 */
export default function MobileNav({ isOpen, open }) {
  const navigate = useNavigate();
  const theme = useContext(ColorContext);
  const [pageButtons, setPageButtons] = useState();
  const [selectedPage, setSelectedPage] = useState('/dashboard');
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;

  const perms = usePerms();

  useEffect(() => {
    setTimeout(() => {
      const sidebarData = [...GetRouteData(perms)];
      sidebarData.forEach((item) => {
        if (item.permission()) {
          item.options.forEach((option) => {
            //set enabled by perm
            if (!option.hideSidebar) option.enabled = option.permission();

            //set active based on location
            if (window.location.pathname === option.href) item.opened = true;
          });
        } else {
          item.enabled = false;
          item.options.forEach((option) => {
            option.enabled = false;
          });
        }
      });

      setSelectedPage(window.location.pathname);
      setPageButtons(sidebarData);
    }, 1000);
  }, [isAuthenticated, perms.data]);

  useEffect(() => {
    if (!isAuthenticated) perms.reset();
  }, [isAuthenticated]);

  const closeAllDropdowns = () => {
    const temp = pageButtons.map((item, iIndex) => {
      return { ...item, opened: false };
    });

    setPageButtons(temp);
  };

  const scrollMainToTop = () => {
    const mainScroll = document.getElementById('main-scroll-container');
    if (mainScroll?.scrollTo) {
      mainScroll.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navigateOrScroll = (href) => {
    if (window.location.pathname === href) {
      scrollMainToTop();
      isOpen(false);
      return;
    }
    navigate(href);
    isOpen(false);
  };

  ////////////
  // Styles //
  ////////////

  const ButtonStyleClosed = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 63,
    alignItems: 'center',
  };

  const ButtonStyleOpen = {
    backgroundColor: theme.primary,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 63,
    alignItems: 'center',
  };

  const DropButtonStyleOpen = {
    backgroundColor: theme.primary,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    paddingLeft: 50,
    height: 63,
    alignItems: 'center',
  };

  const DropButtonStyleSelected = {
    backgroundColor: theme.primaryHighlight,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    paddingLeft: 50,
    height: 63,
    alignItems: 'center',
  };

  if (isAuthenticated && pageButtons)
    return (
      <div
        className={`overflow-x-hidden position-fixed bg-primary-shadow ${
          open && styles.open
        } ${styles.overlay}`}
      >
        <div
          style={{
            marginBottom: 100,
          }}
        >
          {/* Icon header */}
          <Container
            as="header"
            fluid
            className="d-flex justify-content-around p-3 w-100 align-items-center bg-primary"
          >
            <RxHamburgerMenu onClick={() => isOpen(false)} size={30} />
            <img height={59} src={getLogo(true)} alt="Logo" />
            <div style={{ width: '30px', height: '30px' }}></div>
          </Container>
          {/* Home dashboard */}
          <Button
            className="rounded-0 d-flex w-100 align-items-center gap-2"
            style={{ height: 63 }}
            onClick={() => {
              closeAllDropdowns();
              setSelectedPage('/dashboard');
              navigateOrScroll('/dashboard');
            }}
            variant={selectedPage === '/dashboard' ? 'primary' : 'dark'}
          >
            <div className={styles['btn-icon']}>
              <IconContext.Provider value={{ size: 30 }}>
                <FaHome />
              </IconContext.Provider>
            </div>
            <div className="pb-2">Dashboard</div>
          </Button>
          {pageButtons
            .filter(
              (_, index) => index <= pageButtons.findIndex((page) => page.name === 'Public Info'),
            )
            .map((dropdown, index) => {
              if (dropdown.enabled)
                return (
                  <div key={index}>
                    <button
                      style={
                        dropdown.options
                          .map((option) => {
                            return selectedPage === option.href;
                          })
                          .includes(true)
                          ? { ...DropButtonStyleSelected, paddingLeft: 0 }
                          : dropdown.opened
                            ? ButtonStyleOpen
                            : ButtonStyleClosed
                      }
                      // Toggle dropdown menu
                      onClick={() => {
                        const temp = pageButtons.map((item, iIndex) => {
                          if (iIndex === index) {
                            return { ...item, opened: !item.opened };
                          } else {
                            return { ...item, opened: false };
                          }
                        });
                        setPageButtons(temp);
                      }}
                    >
                      <div className="d-flex justify-content-between w-100">
                        <div className="d-flex align-items-center">
                          <div className="mx-3">{dropdown.icon()}</div>
                          <div>{dropdown.name}</div>
                        </div>
                        <div className="me-3">
                          {dropdown.opened ? <FaChevronUp /> : <FaChevronDown />}
                        </div>
                      </div>
                    </button>
                    {dropdown.opened && (
                      <div>
                        {dropdown.options.map((option, index) => {
                          if (option.enabled)
                            return (
                              <Button
                                className="pe-0 py-0 rounded-0"
                                key={index}
                                style={
                                  selectedPage === option.href
                                    ? DropButtonStyleSelected
                                    : DropButtonStyleOpen
                                }
                                onClick={() => {
                                  setSelectedPage(option.href);
                                  navigateOrScroll(option.href);
                                }}
                                variant={selectedPage === option.href ? 'primary' : 'secondary'}
                              >
                                <div className="d-flex align-items-center">
                                  <div className="me-3" style={{ width: 30 }}>
                                    {option.icon()}
                                  </div>
                                  <div>{option.name}</div>
                                </div>
                              </Button>
                            );
                        })}
                      </div>
                    )}
                  </div>
                );
            })}

          {/* ExacqVision VMS */}
          <Button
            className="rounded-0 d-flex w-100 align-items-center gap-2"
            style={{ height: 63 }}
            onClick={() => {
              closeAllDropdowns();
              setSelectedPage('/vms');
              navigateOrScroll('/vms');
            }}
            variant={selectedPage === '/vms' ? 'primary' : 'dark'}
          >
            <div className={styles['btn-icon']}>
              <IconContext.Provider value={{ size: 35 }}>
                <PiVideoFill />
              </IconContext.Provider>
            </div>
            <div className="pb-2">Overwatch VMS</div>
          </Button>

          {/* Maintenance Dashboard*/}
          {perms.maintenanceLevel > 0 && (
            <Button
              className="rounded-0 d-flex gap-2 w-100 align-items-center"
              style={{ height: 63 }}
              onClick={() => {
                closeAllDropdowns();
                setSelectedPage('/maintenancedashboard');
                navigateOrScroll('/maintenancedashboard');
              }}
              variant={selectedPage === '/maintenancedashboard' ? 'primary' : 'dark'}
            >
              <div className={styles['btn-icon']}>
                <IconContext.Provider value={{ size: 35 }}>
                  <PiWrenchFill />
                </IconContext.Provider>
              </div>
              <div className="pb-2">Maintenance Devices</div>
            </Button>
          )}

          {pageButtons
            .filter(
              (_, index) => index > pageButtons.findIndex((page) => page.name === 'Public Info'),
            )
            .map((dropdown, index) => {
              index += 1 + pageButtons.findIndex((page) => page.name === 'Public Info');

              if (dropdown.enabled)
                return (
                  <div key={index}>
                    <button
                      style={
                        dropdown.options
                          .map((option) => {
                            return selectedPage === option.href;
                          })
                          .includes(true)
                          ? { ...DropButtonStyleSelected, paddingLeft: 0 }
                          : dropdown.opened
                            ? ButtonStyleOpen
                            : ButtonStyleClosed
                      }
                      onClick={() => {
                        const temp = pageButtons.map((item, iIndex) => {
                          if (iIndex === index) {
                            return { ...item, opened: !item.opened };
                          } else {
                            return { ...item, opened: false };
                          }
                        });

                        setPageButtons(temp);
                      }}
                    >
                      <div className="d-flex justify-content-between w-100">
                        <div className="d-flex align-items-center">
                          <div className="mx-3">{dropdown.icon()}</div>
                          <div>{dropdown.name}</div>
                        </div>

                        <div className="me-3">
                          {dropdown.opened ? <FaChevronUp /> : <FaChevronDown />}
                        </div>
                      </div>
                    </button>
                    {dropdown.opened && (
                      <div>
                        {dropdown.options.map((option, index) => {
                          if (option.enabled)
                            return (
                              <Button
                                className="pe-0 py-0 rounded-0"
                                style={
                                  selectedPage === option.href
                                    ? DropButtonStyleSelected
                                    : DropButtonStyleOpen
                                }
                                key={index}
                                onClick={() => {
                                  setSelectedPage(option.href);
                                  navigateOrScroll(option.href);
                                }}
                                variant={selectedPage === option.href ? 'primary' : 'secondary'}
                              >
                                <div className="d-flex align-items-center">
                                  <div className="me-3" style={{ width: 30 }}>
                                    {option.icon()}
                                  </div>
                                  <div>{option.name}</div>
                                </div>
                              </Button>
                            );
                        })}
                      </div>
                    )}
                  </div>
                );
            })}
        </div>
      </div>
    );
}
